import { setReducer } from "../../reducer/creators"
import { SET_IS_VISIBLE } from "../actions"

export const isVisible = setReducer<boolean>([SET_IS_VISIBLE], !global.window.document.hidden)
